<h1 mat-dialog-title>Review All Harvests</h1>
<mat-dialog-content style="width: 65vw; height: 65vh;">
  <ag-grid-angular
    style="width: 100%; height: 100%;"
    [gridOptions]="gridOptions"
    [rowData]="harvestFormDataArray"
    [columnDefs]="columnDefs"
    (firstDataRendered)="onFirstDataRendered()"
    class="ag-theme-balham"
    >
  </ag-grid-angular>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="goBack()">Go Back</button>
  @if (!harvestSaveError) {
    <button mat-button (click)="saveAllHarvests()">
      @if (saveClick) {
        <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
      }
      @if (!saveClick) {
        <span>{{ harvestFormDataArray.length > 1 ? 'Save All' : 'Save' }}</span>
      }
    </button>
  }
  @if (harvestSaveError) {
    <button mat-button (click)="goBackAndModify()">
      @if (saveClick) {
        <mat-spinner diameter=25 strokeWidth=4></mat-spinner>
      }
      @if (!saveClick) {
        <span>Modify Unsaved Harvests</span>
      }
    </button>
  }
</mat-dialog-actions>